import { jsx, jsxs } from "react/jsx-runtime";
import { Divider, Typography } from "antd";
const { Text } = Typography;
const style = { fontSize: 12 };
const LayoutFooter = () => {
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(Text, { style, type: "secondary", children: `\xA92014-${(/* @__PURE__ */ new Date()).getFullYear()} \u4E07\u5E2E\u661F\u661F\u5145\u7535\u79D1\u6280\u6709\u9650\u516C\u53F8 All rights reserved.` }),
    /* @__PURE__ */ jsx(Divider, { type: "vertical" }),
    /* @__PURE__ */ jsx(Text, { style, type: "secondary", children: "\u82CFICP\u590714056214\u53F7" }),
    /* @__PURE__ */ jsx(Divider, { type: "vertical" }),
    /* @__PURE__ */ jsx(Text, { style, type: "secondary", children: "\u5EFA\u8BAE\u60A8\u4F7F\u7528Chrome80+\u6D4F\u89C8\u5668\u6D4F\u89C8\u672C\u7F51\u7AD9" })
  ] });
};
var LayoutFooter_default = LayoutFooter;
export {
  LayoutFooter_default as default
};
